import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CAUserDto } from 'src/core/models/administration/user/CAUser.dto';
import { FilterItemDto } from 'src/core/models/request/filter-item.dto';
import { ListResponseDto } from 'src/core/models/request/list-response.dto';
import { Operators } from 'src/core/models/request/operator.enum';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { CrudService } from 'src/core/services/crud/crud.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private operators: Operators,
    private service: CrudService,
    private http: HttpClient,
  ) {}

  protected getApiUrl(type = DtoHasApi): string {
    const apiBase = environment.apis.default.url;

    return apiBase.length > 0 ? apiBase + '/' + type.apiUrl : type.apiUrl;
  }

  getFilter(
    searchTerm: string,
    userType: 'all' | 'agent' | 'evaluator',
    userStatusFilter: 'all' | 'active' | 'passive',
    departmentId: number | null,
  ): FilterItemDto[] {
    const filters: FilterItemDto[] = [];

    if (searchTerm && searchTerm.length > 0) {
      filters.push({
        field: 'quickSearchTerm',
        value: searchTerm,
        operator: this.operators.Contains,
      });
    }

    if (userType === 'agent') {
      filters.push({
        field: 'onlyAgents',
        value: true,
        operator: this.operators.Equals,
      });
    } else if (userType === 'evaluator') {
      filters.push({
        field: 'onlyEvaluators',
        value: true,
        operator: this.operators.Equals,
      });
    }

    if (userStatusFilter === 'active') {
      filters.push({
        field: 'isActive',
        value: true,
        operator: this.operators.Equals,
      });
    } else if (userStatusFilter === 'passive') {
      filters.push({
        field: 'isActive',
        value: false,
        operator: this.operators.Equals,
      });
    } else {
      filters.push({
        field: 'includePassives',
        value: true,
        operator: this.operators.Equals,
      });
    }

    if (departmentId) {
      filters.push({
        field: 'departmentId',
        value: departmentId,
        operator: this.operators.Equals,
      });
    }

    return filters;
  }

  getList(
    filters: FilterItemDto[],
    pageIndex: number,
    itemsPerPage: number,
    simple: boolean,
    all: boolean = false,
  ): Observable<ListResponseDto<CAUserDto>> {
    if (simple) {
      this.service.getSimple<CAUserDto>(CAUserDto, {
        filters: filters,
      });

      const apiUrl = all
        ? this.getApiUrl(CAUserDto) + `/simple-list-all/`
        : this.getApiUrl(CAUserDto) + `/simple-list/`;
      let params = new HttpParams();

      params = params.append('filters', JSON.stringify(filters));
      params = params.append('sorters', JSON.stringify([]));
      params = params.append('skipCount', JSON.stringify(pageIndex * itemsPerPage));
      params = params.append('maxResultCount', JSON.stringify(itemsPerPage));

      return this.http.get(apiUrl, {
        params,
      }) as Observable<ListResponseDto<CAUserDto>>;
    } else {
      return this.service.get<CAUserDto>(CAUserDto, {
        skipCount: pageIndex * itemsPerPage,
        maxResultCount: itemsPerPage,
        filters: filters,
        sorters: [],
      });
    }
  }
}
